<template>
	<div>
		<el-popover
			ref="popover2"
			popper-class="pay-popover"
			placement="top"
			:title="title"
			width="415"
			trigger="click">
			<p>Q1：为什么支付宝提示已经支付，但是订单信息却显示还未支付成功？A1：请您放心，这是由于同时支付的订单数量太多，导致支付宝数据与我们系统数据暂时没有同步。原则上24小时内支付信息会同步正确，建议您注意查看。给您带来不便，请谅解！</p>
			<p>Q4：在线支付订单需要在多长时间内完成付款？A4：我们订单通常自动为您保留24小时，过期后您的订单将会被标记为作废状态。活动期间支付时效以活动通知为准。</p>
			<p>Q5：如何查询是否支付成功？A5：登陆后打开“会员中心 - 我的订单”查询订单状态。</p>
		</el-popover>
		<div v-popover:popover2 class="pointer">
			<i class="el-icon-information green mr10"></i>支付遇到问题
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				title: '在线支付常见问题'
			}
		}
	}
</script>
<style>
	.pay-popover{
		border: 1px solid #4cb707;
		background: #f9fff5;
		padding: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/Payment/components/private-component/PayQues.vue